import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ICreateCommentResponse } from "./types";

export const getAllCommentsByTask = async (taskId: string): Promise<ICreateCommentResponse> => {
  try {
    const response = await apiClientSource.get(`/task-service/api/comments/task/${taskId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los comentarios de la tarea");
    throw error;
  }
}